import { createContext, useContext, useState, useEffect } from 'react';
import { fetchBranding } from '../lib/api';

const BrandingContext = createContext(null);

const defaultBranding = {
  brand_name: 'Maintenova',
  brand_tagline: 'Web Application & Server Support Solutions',
  logo_url: '/images/logo.png',
  favicon_url: null,
  primary_color: '#06b6d4',
  accent_color: '#0ea5e9',
  css_overrides: '',
  login_welcome_text: null,
  hide_maintenova_branding: false,
  is_white_labeled: false,
};

function applyBrandingCssVars(branding) {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', branding.primary_color);
  root.style.setProperty('--color-accent', branding.accent_color);

  // Compute darker variants
  root.style.setProperty('--color-primary-dark', darken(branding.primary_color, 15));
  root.style.setProperty('--color-accent-dark', darken(branding.accent_color, 15));

  // Update favicon if provided
  if (branding.favicon_url) {
    const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = branding.favicon_url;
    document.head.appendChild(link);
  }

  // Update title
  document.title = branding.brand_name;
}

function darken(hex, percent) {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.max(0, (num >> 16) - Math.round(2.55 * percent));
  const g = Math.max(0, ((num >> 8) & 0x00ff) - Math.round(2.55 * percent));
  const b = Math.max(0, (num & 0x0000ff) - Math.round(2.55 * percent));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(defaultBranding);

  useEffect(() => {
    fetchBranding()
      .then((data) => {
        setBranding(data);
        applyBrandingCssVars(data);
      })
      .catch(() => {
        applyBrandingCssVars(defaultBranding);
      });
  }, []);

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  const context = useContext(BrandingContext);
  if (!context) throw new Error('useBranding must be used within BrandingProvider');
  return context;
}
